
import React from "react";
import OrderExtras from '../../SlidePanels/OrderExtras';
import * as actionCreator from "../../../action/index.js";
import { connect } from "react-redux";

class ExtraNotes extends React.Component {
   render() {
      return (
         <div className="building-elements-sec no-price-component">
            <div className="building-elements-sec-mid pt-0">
               <div className="building-elements-sec-mid-scroll">
                  <OrderExtras />
               </div>
            </div>
         </div>
      );
   }
}


const mapStateToProps = (state) => {
   return state.reducer
}
export default connect(
   mapStateToProps,
   //mapDispachToProps,
   actionCreator
)(ExtraNotes);

